import {PageWrapper} from '@freckle/classroom/ts/common/components/page-wrapper'
import {ElaArticleDebugger} from './ela-article-debugger'

export default function ElaArticleDebuggerHandler() {
  return (
    <PageWrapper pageHeaderText="ELA Article Debugger">
      <ElaArticleDebugger />
    </PageWrapper>
  )
}
